import React from 'react'
import {makeStyles} from '@mui/styles'
import {spaceMedium} from '../../assets/styles/spacing'
import SentimentCard from './SentimentCard'
import NPSScoreCard from './NPSScoreCard'
import PropTypes from 'prop-types'
import {renderFloatWithTwoDecimalsIfValIsNotNaN} from './residentSentimentUtilities'

const useStyles = makeStyles(theme => ({
  npsScoreSummaryCards: {
    display: 'flex',
    gap: spaceMedium,
  },
  cardStack: {
    width: '100%',
    marginBottom: spaceMedium,
    display: 'flex',
    gap: spaceMedium,
    '&:last-child': {
      marginBottom: 0,
    },

    '& > div': {
      width: '100%',
      flex: 1,
    },
  },
}))

function RatingSummaryCards({
  npsResponses,
  npsScore,
  npsScoreChange,
  npsScorePercentagePromoters,
  npsScorePercentagePromotersChangeFromLastMonth,
  npsScorePercentagePassives,
  npsScorePercentagePassivesChangeFromLastMonth,
  npsScorePercentageDetractors,
  npsScorePercentageDetractorsChangeFromLastMonth,
  messageSentiment,
  messageSentimentChangeFromLastMonth,
  serviceRating,
  serviceRatingChangeFromLastMonth,
  amenitiesRating,
  amenitiesRatingChangeFromLastMonth,
  maintenanceRating,
  maintenanceRatingChangeFromLastMonth,
  onboardingRating,
  onboardingRatingChangeFromLastMonth,
}) {
  const classes = useStyles({
    npsScorePercentagePromoters,
    npsScorePercentagePassives,
    npsScorePercentageDetractors,
  })

  return (
    <div className={classes.npsScoreSummaryCards}>
      <NPSScoreCard
        cardTitle={'NPS score'}
        compact
        npsResponses={npsResponses}
        npsScore={npsScore}
        npsScoreChange={npsScoreChange}
        npsScorePercentagePromoters={npsScorePercentagePromoters}
        npsScorePercentagePromotersChangeFromLastMonth={npsScorePercentagePromotersChangeFromLastMonth}
        npsScorePercentagePassives={npsScorePercentagePassives}
        npsScorePercentagePassivesChangeFromLastMonth={npsScorePercentagePassivesChangeFromLastMonth}
        npsScorePercentageDetractors={npsScorePercentageDetractors}
        npsScorePercentageDetractorsChangeFromLastMonth={npsScorePercentageDetractorsChangeFromLastMonth}
      />

      <div style={{width: '100%'}}>
        <div className={classes.cardStack}>
          <SentimentCard
            title={'Conversation sentiment'}
            value={renderFloatWithTwoDecimalsIfValIsNotNaN(messageSentiment)}
            denominator={1}
            change={renderFloatWithTwoDecimalsIfValIsNotNaN(messageSentimentChangeFromLastMonth)}
            changeDescription={'from last month'}
          />
          <SentimentCard
            title={'Onboarding rating'}
            value={renderFloatWithTwoDecimalsIfValIsNotNaN(onboardingRating)}
            denominator={1}
            change={renderFloatWithTwoDecimalsIfValIsNotNaN(onboardingRatingChangeFromLastMonth)}
            changeDescription={'from last month'}
          />
        </div>
        <div className={classes.cardStack}>
          <SentimentCard
            title={'Service rating'}
            value={renderFloatWithTwoDecimalsIfValIsNotNaN(serviceRating)}
            denominator={1}
            change={renderFloatWithTwoDecimalsIfValIsNotNaN(serviceRatingChangeFromLastMonth)}
            changeDescription={'from last month'}
          />
          <SentimentCard
            title={'Maintenance rating'}
            value={renderFloatWithTwoDecimalsIfValIsNotNaN(maintenanceRating)}
            denominator={1}
            change={renderFloatWithTwoDecimalsIfValIsNotNaN(maintenanceRatingChangeFromLastMonth)}
            changeDescription={'from last month'}
          />
          <SentimentCard
            title={'Amenities rating'}
            value={renderFloatWithTwoDecimalsIfValIsNotNaN(amenitiesRating)}
            denominator={1}
            change={renderFloatWithTwoDecimalsIfValIsNotNaN(amenitiesRatingChangeFromLastMonth)}
            changeDescription={'from last month'}
          />
        </div>
      </div>
    </div>
  )
}

RatingSummaryCards.propTypes = {
  npsResponses: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
  npsScore: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
  npsScoreChange: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
  npsScorePercentagePromoters: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
  npsScorePercentagePromotersChangeFromLastMonth: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
  npsScorePercentagePassives: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
  npsScorePercentagePassivesChangeFromLastMonth: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
  npsScorePercentageDetractors: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
  npsScorePercentageDetractorsChangeFromLastMonth: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
  messageSentiment: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
  messageSentimentChangeFromLastMonth: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
  serviceRating: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
  serviceRatingChangeFromLastMonth: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
  amenitiesRating: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
  amenitiesRatingChangeFromLastMonth: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
  maintenanceRating: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
  maintenanceRatingChangeFromLastMonth: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['NaN'])]).isRequired,
}

export default RatingSummaryCards
